'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import Logo from '@/entites/logo/ui/Logo';

const footerItems = [
  {
    title: 'addr_title',
    content: '山东省 青岛市 城阳区 城阳街道 春阳路86号23号楼 5层',
  },
  {
    title: 'tel_title',
    content: '0532 8772 3377',
  },
  {
    title: 'mail_title',
    content: 'call@koreavisa-qd.com',
  },
];

const PcFooter = () => {
  const t = useTranslations('main.footer');
  return (
    <footer className="w-full mx-auto">
      <div className={'bg-primary-600 px-[30px] pt-[40px] pb-[50px]'}>
        <div className={'max-w-[1280px] mx-auto'}>
          <div className={'inline-block'}>
            <Logo theme={'white'} />
          </div>
          <div
            className={
              'mt-[20px] flex gap-x-[142px] text-[14px] font-normal text-[#FFFFFF] line-height-[24px]'
            }
          >
            {footerItems.map((item) => (
              <div key={t(item.title)}>
                <div className={'font-semibold'}>{t(item.title)}</div>
                <div className={'font-normal text-[#80A6FF]'}>{item.content}</div>
              </div>
            ))}
          </div>
          <div className={'h-[1px] w-full bg-[#80A6FF] my-[20px]'}></div>
          <div className={'text-[13px] flex justify-between text-[#80A6FF]'}>
            <div>{t('company_name')} ㅣ Copyright ⓒ 大韩民国签证申请中心</div>
            <div className="w-[175px] flex justify-between items-center">
              <Link
                className="text-[13px] font-semibold text-white hover:text-primary-200 hover:font-semibold"
                href={{
                  pathname: '/terms',
                  hash: '#terms-privacy-policy-h1',
                }}
              >
                {t('terms')}
              </Link>
              <Link
                className="text-[13px] font-semibold text-white hover:text-primary-200"
                href={{
                  pathname: '/privacy-policy',
                  hash: '#terms-privacy-policy-h1',
                }}
              >
                {t('privacy_policy')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PcFooter;
